import React from 'react';

// Pergola-specific quote form fields.
export default function PergolaFields() {
  return (
    <>
      <div className="asg-form-row">
        <div className="asg-form-group">
          <label className="asg-form-label">Which model?</label>
          <select className="asg-select" name="model" defaultValue="">
            <option value="" disabled>Select</option>
            <option value="Pergola 163">Pergola 163</option>
            <option value="Pergola 175">Pergola 175</option>
            <option value="Pergola 180 Retractable">Pergola 180 Retractable</option>
            <option value="Not sure yet">Not sure yet</option>
          </select>
        </div>
        <div className="asg-form-group">
          <label className="asg-form-label">Approx. dimensions (L × W)</label>
          <input type="text" className="asg-input" name="total_size" placeholder="e.g. 6m × 4m" />
        </div>
      </div>
      <div className="asg-form-row">
        <div className="asg-form-group">
          <label className="asg-form-label">Configuration</label>
          <select className="asg-select" name="stands" defaultValue="">
            <option value="" disabled>Select</option>
            <option value="Freestanding - 4 posts">Freestanding (4 posts)</option>
            <option value="Wall-mounted - 2 posts">Wall-mounted (2 posts)</option>
            <option value="Not sure yet">Not sure yet</option>
          </select>
        </div>
      </div>
      <div className="asg-form-group">
        <label className="asg-form-label">Optional extras</label>
        <div className="asg-checkbox-row">
          <label className="asg-checkbox-label"><input type="checkbox" name="attachments[]" value="LED Lighting" /> LED Lighting</label>
          <label className="asg-checkbox-label"><input type="checkbox" name="attachments[]" value="Glass walls" /> Glass walls</label>
          <label className="asg-checkbox-label"><input type="checkbox" name="attachments[]" value="Heaters" /> Heaters</label>
        </div>
      </div>
    </>
  );
}
